<template>
  <v-content>
    <v-layout column style="width: 280px">
      <v-flex class="cea-underline">
        <div class="py-5 px-12 mb-3 d-flex align-center justify-center">
          <img :src="require('../assets/logo.png')" />
        </div>

        <v-layout justify-start mb-4 px-3>
          <v-flex shrink mr-2>
            <img :src="require('../assets/profile.png')" style="border-radius: 100%; width: 45px; height: 45px" />
          </v-flex>
          <v-flex text-start>
            <div class="txt-head cea-color">Admin :</div>
            <v-menu offset-y open-on-hover max-width="180">
              <template v-slot:activator="{ on }">
                <div v-if="userDetail.first_name === undefined" class="txt-detail cea-color">
                  Logging out..
                </div>
                <div v-else class="txt-detail" style="cursor: pointer" v-on="on">
                  {{ userDetail.first_name + " " + userDetail.last_name }}
                </div>
              </template>
              <v-list>
                <v-list-item @click="onUserLogOut(userData.token)">
                  <v-list-item-title class="red--text">
                    <v-icon color="red" class="mr-3">exit_to_app</v-icon>
                    ออกจากระบบ
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-treeview id="side-menu" class="text-start cea-color" :items="menulist" open-on-click :open="[1]"
          :active="[2]" @update:active="menuChange" activatable color="#FF4F23" hoverable></v-treeview>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "SideBar",
  data: () => ({
    dataToken: {},
    menulist: [
      {
        id: 1,
        name: "การจัดการ Dashboard",
        children: [
          // { id: 2, name: "Data & Statistics" },
          // { id: 3, name: "Research & Report" },
          // { id: 4, name: 'Creativity Index' },
          { id: 5, name: "About" },
          // { id: 24, name: "กล่องข้อมูล Overview" },
          // { id: 25, name: "กล่องข้อมูล Data & stats" },
        ],
      },
      // {
      //   id: 6,
      //   name: "การจัดการกลุ่มอุตสาหกรรมสร้างสรรค์",
      //   children: [
      //     { id: 7, name: "กิจกรรมทางเศรษฐกิจ" },
      //     { id: 8, name: "กลุ่มอุตสาหกรรม" },
      //   ],
      // },
      // {
      //   id: 9,
      //   name: "การจัดการกลุ่มอาชีพสร้างสรรค์",
      //   children: [
      //     // { id: 10, name: 'อาชีพสร้างสรรค์' },
      //     { id: 11, name: "กลุ่มอาชีพสร้างสรรค์" },
      //   ],
      // },
      // {
      //   id: 12,
      //   name: "การจัดการกลุ่มตัวชี้วัด",
      //   children: [
      //     { id: 13, name: "ตัวชี้วัด" },
      //     { id: 14, name: "กลุ่มตัวชี้วัด" },
      //   ],
      // },
      {
        id: 28,
        name: "จัดการ Power BI",
        children: [
          { id: 27, name: "Main page" },
          { id: 29, name: "Creative index page" },
          { id: 30, name: "Data and Statistics page" },
        ],
      },
      {
        id: 15,
        name: "การจัดการข้อมูล",
        children: [
          { id: 16, name: "หัวข้อการนำเข้า" },
          { id: 17, name: "การนำเข้าด้วยไฟล์ Excel" },
          { id: 18, name: "หน่วยของข้อมูล" },
          { id: 19, name: "Tag" },
          { id: 26, name: "Banner" },
          // { id: 27, name: "Power Bi" },
          { id: 22, name: "Footer" },
          { id: 34, name: "Main Menu" },
        ],
      },
      {
        id: 20,
        name: "การจัดการผู้ใช้งาน",
        children: [{ id: 21, name: "ผู้ใช้งาน" }],
      },
      {
        id: 31,
        name: "สำหรับนักพัฒนา",
        children: [
          { id: 32, name: "การจัดการชุดข้อมูล" },
          /**
          * Author: thiracupt ponngern
          * Detail: add ckan group menu
          */
          { id: 33, name: "การจัดการกลุ่มบริการ (CKAN)" }
        ],
      },
      {
        id: 23,
        name: "ดาวน์โหลด",
        children: [{ id: 23, name: "เอกสารสำหรับดาวน์โหลด" }],
      },
    ],
  }),
  computed: {
    ...mapState({
      userData: (state) => state.auth.userData,
      userDetail: (state) => state.auth.userDetail,
    }),
  },
  methods: {
    ...mapActions("auth", ["onGetUserDetail", "onUserLogOut"]),
    menuChange(id) {
      // props sender
      switch (id[0]) {
        case 2:
          this.$router.push("/dashboard/data-and-stats");
          break;
        case 3:
          this.$router.push("/dashboard/report");
          break;
        case 4:
          this.$router.push("/dashboard/cindex");
          break;
        case 5:
          this.$router.push("/dashboard/about");
          break;
        case 7:
          this.$router.push("/creative-industries/tsic");
          break;
        case 8:
          this.$router.push("/creative-industries/group");
          break;
        case 10:
          this.$router.push("/creative-jobs/jobs");
          break;
        case 11:
          this.$router.push("/creative-jobs/jobs-group");
          break;
        case 13:
          this.$router.push("/index-manager/index");
          break;
        case 14:
          this.$router.push("/index-manager/index-group");
          break;
        case 16:
          this.$router.push("/data-manager/title");
          break;
        case 17:
          this.$router.push("/data-manager/import");
          break;
        case 18:
          this.$router.push("/data-manager/unit");
          break;
        case 19:
          this.$router.push("/data-manager/tag");
          break;
        case 21:
          this.$router.push("/user-manager/users");
          break;
        case 22:
          this.$router.push("/data-manager/footer");
          break;
        case 23:
          this.$router.push("/downloads");
          break;
        case 24:
          this.$router.push("/data-manager/number-box");
          break;
        case 25:
          this.$router.push("/creative-industries/number-box-datastats");
          break;
        case 26:
          this.$router.push("/data-manager/banner");
          break;
        case 27:
          this.$router.push("/power-bi-manage/main-page");
          break;
        case 29:
          this.$router.push("/power-bi-manage/creative-index-page");
          break;
        case 30:
          this.$router.push("/power-bi-manage/data-and-static-page");
          break;
        //    TODO add router for manage Developer
        case 32:
          this.$router.push("/developer-manage/manage");
          break;
        /**
        * Author: thiracupt ponngern
        * Detail: add id for new route
        */
        case 33:
          this.$router.push("/developer-manage/manage-group");
          break;
        case 34:
          this.$router.push("/data-manager/main-menu");
          break;
      }
    },
  },
  created() {
    this.dataToken.token = this.userData.token;
    this.onGetUserDetail(this.dataToken);
    // console.log(this.userDetail)
  },
};
</script>

<style lang="scss">
.v-application--is-ltr .v-treeview .v-treeview-node--leaf {
  margin-left: 0 !important;
}
</style>
